import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { Lock as LockIcon } from "@mui/icons-material";

interface ProtectedUserBadgeProps {
  protectionReason?: string;
  size?: "small" | "medium";
}

/**
 * Badge to indicate a protected user
 * Shows lock icon with tooltip explaining protection
 */
export const ProtectedUserBadge: React.FC<ProtectedUserBadgeProps> = ({
  protectionReason,
  size = "small",
}) => {
  const tooltipText = protectionReason
    ? `Suojattu käyttäjä: ${protectionReason}`
    : "Suojattu käyttäjä - Vain pääkäyttäjä voi muokata henkilötietoja";

  return (
    <Tooltip title={tooltipText}>
      <Chip
        icon={<LockIcon />}
        label="Suojattu"
        size={size}
        color="warning"
        variant="outlined"
      />
    </Tooltip>
  );
};
